import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { MemoryRouter, useLocation } from 'react-router-dom';
import { Queue, MessageType, postMessage } from '../utility';
import { AuditRecord } from './AuditRecord';
import client from '../http-client';

const Auditor = ({ auditQueue, pageHash }) => {
	let location = useLocation();
	postMessage(MessageType.KEEP_ALIVE);
	auditQueue.add(new AuditRecord(location.pathname, pageHash));

	return null;
};

const send = auditRecords => {
	if (process.env.NODE_ENV === 'test') {
		// eslint-disable-next-line no-console
		console.log(auditRecords);
		return;
	}

	client
		.post('shared/ui', {
			ReactUserInterfaceService: 'audit',
			auditRecords: JSON.stringify(auditRecords)
		})
		.catch(() => {
			// ignore
		});
};

export function AuditMemoryRouter({ pageHash, children, ...props }) {
	const auditQueueRef = useRef(new Queue(send));
	const auditQueue = auditQueueRef.current;

	useEffect(() => {
		return () => auditQueue.cleanup();
	}, [auditQueue]);

	return (
		<MemoryRouter {...props}>
			<Auditor auditQueue={auditQueue} pageHash={pageHash} />
			{children}
		</MemoryRouter>
	);
}

AuditMemoryRouter.propTypes = {
	/**
	 * pageHash entry.  Matches initial pageHit that rendered the application
	 */
	pageHash: PropTypes.string,
	children: PropTypes.node
};
